// Import dependencies
import { AutomatorBuilderItem } from '../_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-trigger' )
export class AutomatorBuilderTrigger extends AutomatorBuilderItem {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The item type
	type = 'trigger';

	/**
	 * The items/actions displayed in the menu (ellipsis icon)
	 *
	 * @return {Array} An array of TemplateResult, each one representing an action
	 */
	get menuItems() {
		return [
			this._templateMenuButtonDelete,
			this._templateMenuButtonSupport
		];
	}
}
